var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "back"
  }, [_c('k-image', {
    attrs: {
      "src": "//cdn-static.kwai.net/kos/s101/nlav11312/live/events/global/icon_back.png",
      "alt": ""
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.goBack.apply(null, arguments);
      }
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }